import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "card",
  id: "Clinician__Patients"
}
const _hoisted_2 = { class: "d-flex align-items-center py-2 px-3 bg-primary text-white font-size-md fw-bold" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " Patients ", -1 /* HOISTED */)
const _hoisted_4 = { class: "ms-2 fas fa-question-circle" }
const _hoisted_5 = { class: "d-flex p-2" }
const _hoisted_6 = { class: "input-group-append ms-2" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_9 = { class: "d-flex align-items-center font-size-md" }
const _hoisted_10 = {
  key: 0,
  class: "ms-1 fas fa-gift text-app-primary"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = { class: "text-default pt-1" }
const _hoisted_14 = { class: "d-flex pt-1" }
const _hoisted_15 = {
  key: 0,
  class: "d-flex align-items-center me-4"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-mobile text-primary me-1" }, null, -1 /* HOISTED */)
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-birthday-cake text-primary me-1" }, null, -1 /* HOISTED */)
const _hoisted_20 = {
  key: 1,
  class: "d-flex flex-column w-100 align-items-center text-center py-5 px-3 text-primary"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cogs fa-5x mb-4" }, null, -1 /* HOISTED */)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "font-size-lg" }, [
  /*#__PURE__*/_createTextVNode(" We are fetching your current patient list."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" We will have your patient list ready in a moment. ")
], -1 /* HOISTED */)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = {
  key: 2,
  class: "error-state"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("There was a problem while fetching your patients."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Please try again.")
], -1 /* HOISTED */)
const _hoisted_26 = {
  key: 3,
  class: "no-data"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", null, " No patient found. ", -1 /* HOISTED */)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 4,
  class: "no-data"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", null, "You have not worked with any patients yet.", -1 /* HOISTED */)
const _hoisted_31 = [
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductPill = _resolveComponent("ProductPill")!
  const _component_ScrollPagination = _resolveComponent("ScrollPagination")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("i", _hoisted_4, null, 512 /* NEED_PATCH */), [
        [_directive_tooltip, { title: _ctx.tooltip, placement: 'right' }]
      ]),
      _createElementVNode("i", {
        class: "ms-auto fas fa-times",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closePatients()))
      })
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.getData && _ctx.getData(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          autofocus: "",
          class: "form-control",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
          placeholder: "Search by Patient Name"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.searchQuery]
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "submit",
            disabled: _ctx.disableForm,
            class: "btn btn-primary"
          }, "Search", 8 /* PROPS */, _hoisted_7)
        ])
      ])
    ], 32 /* HYDRATE_EVENTS */),
    _createVNode(_component_ScrollPagination, {
      class: "content-y h-100",
      "page-number": _ctx.pageNumber,
      "all-pages-loaded": _ctx.allPagesLoaded,
      "is-loading": _ctx.isLoading,
      "has-error": _ctx.hasError,
      onPageNumberUpdate: _ctx.pageNumberUpdated
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", {
          class: _normalizeClass(["d-flex flex-column overflow-auto flex-nowrap w-100 h-100 scroll-paginate", `${_ctx.userOs == 'Windows' ? 'custom-scrollbar' : ''}`])
        }, [
          (_ctx.patientsList.length && !_ctx.isLoading && !_ctx.hasError)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.patientsList, (patient) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "employee-card",
                  key: patient.Id
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, [
                      _createElementVNode("b", null, _toDisplayString(patient.patientFullName), 1 /* TEXT */),
                      (patient.isBirthDate)
                        ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_10, null, 512 /* NEED_PATCH */)), [
                            [_directive_tooltip, { title: patient.birthDateTooltip, trigger: `manual`, hideWait: 2000 }]
                          ])
                        : _createCommentVNode("v-if", true)
                    ]),
                    (!patient.IsAxxessCARE)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "align-self-start",
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.viewPatient(patient))
                        }, " View Chart ", 8 /* PROPS */, _hoisted_11))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_ProductPill, {
                      class: "application-name",
                      "product-id": _ctx.getApplicationId(patient.Application)
                    }, null, 8 /* PROPS */, ["product-id"])
                  ]),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(patient.AgencyName), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_14, [
                    (patient.PhoneNumber)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("a", {
                            href: 'tel:' + patient.PhoneNumber
                          }, _toDisplayString(_ctx.formatPhone(patient.PhoneNumber)), 9 /* TEXT, PROPS */, _hoisted_17)
                        ]))
                      : _createCommentVNode("v-if", true),
                    (patient.Dob)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(patient.Dob, "MMM DD, YYYY")), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" WAITING "),
          (_ctx.isLoading && !_ctx.hasError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _hoisted_23))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" ERROR "),
          (_ctx.hasError && !_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getData()))
                }, "Try Again")
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" NO DATA "),
          (_ctx.patientsList.length === 0 && _ctx.searchQuery.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_26, _hoisted_28))
            : (_ctx.patientsList.length === 0 && !_ctx.isLoading && !_ctx.hasError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_29, _hoisted_31))
              : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["page-number", "all-pages-loaded", "is-loading", "has-error", "onPageNumberUpdate"])
  ]))
}